import React from 'react'
import { func, number } from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { compositionDataItemsType } from 'models/propTypes'

import Icon from 'components/uiElements/Icon'

require('./CompositionSelection.scss')

const CompositionSelection = ({ compositionDataItems, onOpenComposition, selectedCompositionId, close }) => {
    const { t } = useTranslation()
    return (
        <div className={classNames('CompositionSelection')}>
            <div className="compositionSelectionContent">
                <Icon code="cross" className="selectionClose" onClick={close} />
                <div className="selectionHeader">
                    <h1>{t('design.open design')}</h1>
                    <h2>{t('design.open one design')}</h2>
                </div>
                <div className="compositionItemsContainer">
                    <div className="compositionItems">
                        {compositionDataItems.map((item) => {
                            const selected = item.id === selectedCompositionId

                            return (
                                <div
                                    className="compositionThumbContainer"
                                    key={item.id}
                                    onClick={() => {
                                        const trackingInfo = {
                                            DesignName: item.name,
                                            DesignId: item.id,
                                            RoomId: item.sceneId,
                                        }
                                        onOpenComposition(item.id, trackingInfo)
                                        close()
                                    }}
                                >
                                    <div className={classNames('compositionThumb', { selected })}>
                                        <div className="thumb" style={{ backgroundImage: `url('${item.thumbUrl}')` }} />
                                        <div className="text">{item.name}</div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

CompositionSelection.propTypes = {
    compositionDataItems: compositionDataItemsType.isRequired,
    onOpenComposition: func.isRequired,
    selectedCompositionId: number.isRequired,
    close: func.isRequired,
}

export default CompositionSelection
